import { pageConfig } from '@/common/service/page-config';

const modules = require.context('./', true, /[A-Z$]\/index\.js$/);

/**
 * @param state
 * @return {Function}
 */
const Flow = modules
  .keys()
  .reduce((pre, key) => {
    return {
      ...pre,
      ...modules(key).default,
    };
  }, {})?.[pageConfig.type];

export default new Flow;